const DeepRoute = {
  CALL: {
    name: 'deep_call',
    path: '/app/call',
  },
  ROOM: {
    name: 'deep_room',
    path: '/app/room/:id',
  },
  RESET_PASSWORD: {
    name: 'deep_reset_password',
    path: '/app/reset-password/:id',
  },
  PAYMENT: {
    name: 'deep_payment',
    path: '/app/payment',
  },
  PAYMENT_SUCCESS: {
    name: 'deep_payment_success',
    path: '/app/payment-success',
  },
  AUTH: {
    name: 'deep_auth',
    path: '/app/auth',
  },
};

export const routeTitleMap = {
  [DeepRoute.AUTH.name]: 'deepLink.auth',
  [DeepRoute.PAYMENT.name]: 'deepLink.default',
  [DeepRoute.PAYMENT_SUCCESS.name]: 'deepLink.paymentSuccess',
  [DeepRoute.CALL.name]: 'deepLink.default',
  [DeepRoute.RESET_PASSWORD.name]: 'deepLink.resetPassword',
};

const APP_CUSTOM_PROTOCOL = process.env.VUE_APP_MOOZ_CUSTOM_PROTOCOL;
const APP_CUSTOM_PROTOCOL_CHECK_TIMEOUT = 2000;

export {
  APP_CUSTOM_PROTOCOL_CHECK_TIMEOUT,
  APP_CUSTOM_PROTOCOL,
  DeepRoute,
};